module.exports = ".button-versao {\n    margin-top: 20px;\n}\n\n.msg-erro {\n    color: #FF5050;\n    font-weight: bold;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal/confirmar-fta-modal/confirmar-fta-modal.component.css
// module id = ./src/app/modal/confirmar-fta-modal/confirmar-fta-modal.component.css
// module chunks = main